(function () {
  if (customElements.get('posters-carousel')) return;

  // Native smooth scroll is reset by a third-party embed on this site, so animate by hand
  function animateScroll(el, to) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      el.scrollTo({ left: to, behavior: 'instant' });
      return;
    }
    const from = el.scrollLeft;
    const dist = to - from;
    const duration = 450;
    let start = null;
    el.style.scrollSnapType = 'none';
    function step(t) {
      if (start === null) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.scrollLeft = from + dist * eased;
      if (p < 1) requestAnimationFrame(step);
      else el.style.scrollSnapType = '';
    }
    requestAnimationFrame(step);
  }

  class PostersCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.posters__track');
      this.arrows = this.querySelectorAll('.posters__arrow');
      if (!this.track || !this.arrows.length) return;
      this.onClick = (e) => this.go(Number(e.currentTarget.dataset.dir));
      this.onScroll = () => this.update();
      this.arrows.forEach((b) => b.addEventListener('click', this.onClick));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.arrows.forEach((b) => b.removeEventListener('click', this.onClick));
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    step() {
      const item = this.track.querySelector('.posters__item');
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(dir) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const step = this.step();
      const current = Math.round(this.track.scrollLeft / step);
      const to = Math.max(0, Math.min(max, (current + dir) * step));
      animateScroll(this.track, to);
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const [prev, next] = this.arrows;
      if (prev) prev.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft >= max - 2;
    }
  }

  customElements.define('posters-carousel', PostersCarousel);
})();
